import { Typography, Button, Box, Card } from '@mui/joy';
import { Link } from 'react-router-dom';
import { AppIcon } from '../../components/AppIcon';

const AccessDenied: React.FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                textAlign: 'center',
                padding: 2,
            }}
        >
            <Card className="flex flex-col items-center justify-center">
                <Typography level="h2" color="danger" sx={{ mt: 2 }}>
                    <AppIcon icon="ExclamationTriangleIcon" size="lg" />
                </Typography>
                <Typography level="h2" color="danger">
                    Accès Refusé
                </Typography>
                <Typography sx={{ mt: 2, mb: 3 }}>
                    Vous n'avez pas les permissions nécessaires pour accéder à
                    cette page.
                </Typography>
                <Button
                    component={Link}
                    to="/home"
                    variant="soft"
                    color="primary"
                    startDecorator={<AppIcon icon="HomeIcon" />}
                >
                    Retour à l'accueil
                </Button>
            </Card>
        </Box>
    );
};

export default AccessDenied;
